
import { fetchDataGetReq, fetchDataPutReq, fetchDataPostReq } from '../apis/apiUtil';
import axios from 'axios';


class CommonService {
  getEntityNameByProject(data) {
    const url = `getEntityNameByProject`;
    return fetchDataPutReq(url, data);
  }
  getProductTypeList() {
    const url = `getListProductType`;
    return fetchDataGetReq(url);
  }
  getCountryTerritoryList() {
    const url = `getListCountry`;
    return fetchDataGetReq(url);
  }

  getServiceTypeList() {
    const url = `getListServiceType`;
    return fetchDataGetReq(url);
  }

  getTechnologyTypeList() {
    const url = `getListTechnologyType`;
    return fetchDataGetReq(url);
  }

  getListMpProductType() {
    const url = `getListMpProductType`;
    return fetchDataGetReq(url);
  }

  getListMpRegionCountry() {
    const url = `getListMpRegionCountry`;
    return fetchDataGetReq(url);
  }

  getRegulationStatus() {
    const url = `getRegulationStatus`;
    return fetchDataGetReq(url);
  }

  getApplicationLuData() {
    const url = `getApplicationLuData`;
    return fetchDataGetReq(url);
  }

  checkIsParentCompany(data) {
    const url = `checkIsParentCompany`;
    return fetchDataPutReq(url, data);
  }

  getIndividualClientsMap(data) {
    const url = `getIndividualClientsMap`;
    return fetchDataPutReq(url, data);
  }

  getMapClientID(data) {
    const url = `getMapClientID`;
    return fetchDataPutReq(url, data);
  }

  getIACertUploadProjectBrandNames(data) {
    const url = `getIACertUploadProjectBrandNames`;
    return fetchDataPutReq(url, data);
  }

  getBVLocationCertListReact(data) {
    const url = `getBVLocationCertListReact`;
    return fetchDataPutReq(url, data);
  }
  //getModelNamesWithIAProjects
  getBrandNamesCertProjects(data) {
    const url = `getBrandNamesCertProjects`;
    return fetchDataPutReq(url, data);
  }
  getModelNamesCertProjects(data) {
    const url = `getModelNamesCertProjects`;
    return fetchDataPutReq(url, data);
  }
  getCountryCertProjectsReact(data) {
    const url = `getCountryCertProjectsReact`;
    return fetchDataPutReq(url, data);
  }

  /* Api calls for Projects Tab */
  getBrandNames(listObjLuCompany) {
    const url = 'getBrandNames';
    return fetchDataPutReq(url, listObjLuCompany);
  }

  searchAllProjects(data) {
    const url = `searchAllProjects`;
    return fetchDataPutReq(url, data);
  }

  getProjectPieChartSearchList(data) {
    const url = `getProjectPieChartSearchList`;
    return fetchDataPutReq(url, data);
  }

  searchSubProjects(data) {
    const url = `searchSubProjects`;
    return fetchDataPutReq(url, data);
  }

  getIACertUploadProjectBrandNamesReact(data) {
    const url = `getIACertUploadProjectBrandNamesReact`;
    return fetchDataPutReq(url, data);
  }

  getWoBrandNames(data) {
    const url = `getWoBrandNames`;
    return fetchDataPutReq(url, data);
  }

  getWoCountry(data) {
    const url = `getWoCountry`;
    return fetchDataPutReq(url, data);
  }

  getWoModelNames(data) {
    const url = `getWoModelNames`;
    return fetchDataPutReq(url, data);
  }

  getSubProjectCounts(data) {
    const url = `getSubProjectCounts`;
    return fetchDataPutReq(url, data);
  }

  getBrandNamesCertProjectsReact(data) {
      const url = `getBrandNamesCertProjectsReact`;
      return fetchDataPutReq(url, data);
  }

  getModelNamesCertProjects(data) {
      const url = `getModelNamesCertProjects`;
      return fetchDataPutReq(url, data);
  }

  getCountryCertProjects(data) {
    const url = `getCountryCertProjects`;
    return fetchDataPutReq(url, data);
  }

  getCertificateRenewalCounts(data) {
    const url = `getCertificateRenewalCounts`;
    return fetchDataPutReq(url, data);
  }

  getCertificateExpiryCounts(data) {
    const url = `getCertificateExpiryCounts`;
    return fetchDataPutReq(url, data);
  }
  searchApprovalsBOMLazyLoadReact(data) {
    const url = `searchApprovalsBOMLazyLoadReact`;
    return fetchDataPutReq(url, data);
  }
  getRegulationsListReact(data) {
    const url = `getRegulationsListReact`;
    return fetchDataPutReq(url, data);
  }

  generateOTPForApprClientLogin(data) {
    const url = `auth/generateOTPForApprClientLogin`;
    return fetchDataPostReq(url, data);
  }

    /* Api calls for Projects Tab */
  getBrandNames(listObjLuCompany) {
    const url = 'getBrandNames';
    return fetchDataPutReq(url, listObjLuCompany);
  }

  verifyOTPForApprClientLogin(data) {
    const url = `auth/verifyOTPForApprClientLogin`;
    return fetchDataPostReq(url, data);
  }

  getUserAssociatedCompanyList(data) {
    const url = `getUserAssociatedCompanyList`;
    return fetchDataPutReq(url, data);
  }

  getLoggedInUserDetails(data) {
    const url = `getLoggedInUserDetails`;
    return fetchDataPutReq(url, data);
  }

  getVendorInfo(data) {
    const url = `getVendorInfo`;
    return fetchDataPutReq(url, data);
  }

    searchSubProjects(data) {
        const url = `searchSubProjects`;
        return fetchDataPutReq(url, data);
    }

    getWoBrandNames(data) {
        const url = `getWoBrandNames`;
        return fetchDataPutReq(url, data);
    }

    getWoCountry(data) {
        const url = `getWoCountry`;
        return fetchDataPutReq(url, data);
    }

    getWoModelNames(data) {
        const url = `getWoModelNames`;
        return fetchDataPutReq(url, data);
    }

    getSubProjectCounts(data) {
        const url = `getSubProjectCounts`;
        return fetchDataPutReq(url, data);
    }

    getCountryCertProjects(data) {
        const url = `getCountryCertProjects`;
        return fetchDataPutReq(url, data);
    }

    getCertificateRenewalCounts(data) {
        const url = `getCertificateRenewalCounts`;
        return fetchDataPutReq(url, data);
    }

    getCertificateExpiryCounts(data) {
        const url = `getCertificateExpiryCounts`;
        return fetchDataPutReq(url, data);
    }
    getBrandNamesCertProjectsReact(data) {
        const url = `getBrandNamesCertProjectsReact`;
        return fetchDataPutReq(url, data);
    }
    searchApprovalsBOMLazyLoadReact(data) {
        const url = `searchApprovalsBOMLazyLoadReact`;
        return fetchDataPutReq(url, data);
    }
    getRegulationsListReact(data) {
        const url = `getRegulationsListReact`;
        return fetchDataPutReq(url, data);
    }
    getBrandNamesWithIAProjects(data) {
        const url = `getBrandNamesWithIAProjects`;
        return fetchDataPutReq(url, data);
    }
    //Regulation Library APIs
    getRegulatoryLibrary(data) {
        const url = `getRegulatoryLibrary`;
        return fetchDataPutReq(url, data);
    }
    getDocument(data) {
        const url = `getDocument`;
        return fetchDataPutReq(url, data);
    }

    checkClient(data) {
      const url = `checkClient`;
      return fetchDataPutReq(url, data);
    }

    async fetchIpAddress() {
      return await axios.get('https://api.ipify.org?format=json');
    }

    logUserActivity(strLoggedInUser, intActivityId) {
    this.fetchIpAddress().then((res) => {
      const obj = {
      strIpAdress: res.data.ip,
      strLoggedInUser: strLoggedInUser,
      intActivityId: intActivityId
      };

      const url = `logUserActivity`;
      fetchDataPutReq(url, obj);
    });
    }

  getVendorClients(data) {
    const url = `getVendorClients`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjCountries(data) {
    const url = `getVendorSubProjCountries`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjServiceTypes(data) {
    const url = `getVendorSubProjServiceTypes`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjProdSubSeg(data) {
    const url = `getVendorSubProjProdSubSeg`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjTechType(data) {
    const url = `getVendorSubProjTechType`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjAssignees(data) {
    const url = `getVendorSubProjAssignees`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjBussinessUnits(data) {
    const url = `getVendorSubProjBussinessUnits`;
    return fetchDataPutReq(url, data);
  }

  getVendorSubProjBrandNames(data) {
    const url = `getVendorSubProjBrandNames`;
    return fetchDataPutReq(url, data);
  }

  getVendorPortalNotificationList(data) {
    const url = `getVendorPortalNotificationList`;
    return fetchDataPutReq(url, data);
  }

  getModelNames(data) {
    const url = `getModelNames`;
    return fetchDataPutReq(url, data);
  }

  getServiceCode(data) {
    const url = `getServiceCode`;
    return fetchDataPutReq(url, data);
  }

  getModelNamesWithIAProjects(data) {
    const url = `getModelNamesWithIAProjects`;
    return fetchDataPutReq(url, data);
  }

  getAllNotificationsCount(data, url) {
    url = url;
    return fetchDataPutReq(url, data);
  }

  getBVLocationList(data) {
    const url = `getBVLocationList`;
    return fetchDataPutReq(url, data);
  }

  getBVLocationCertList(data) {
    const url = `getBVLocationCertList`;
    return fetchDataPutReq(url, data);
  }

  getClientProductlst(data) {
    const url = `getClientProductlst`;
    return fetchDataPutReq(url, data);
  }

  getSubscriptionDetails(data) {
    const url = `getSubscriptionDetails`;
    return fetchDataPutReq(url, data);
  }

  getBrandNamesWithIAProjects(data) {
    const url = `getBrandNamesWithIAProjects`;
    return fetchDataPutReq(url, data);
  }
  getClientUserScreenAccess(data) {
    const url = `getClientUserScreenAccess`;
    return fetchDataPutReq(url, data);
  }
  getClientUserConsentFlag(data) {
    const url = `getClientUserConsentFlag`;
    return fetchDataPutReq(url, data);
  }
  updateConsentAcceptedDateByEmail(data) {
    const url = `updateConsentAcceptedDateByEmail`;
    return fetchDataPutReq(url, data);
  }
  signout(data) {
    const url = `auth/signout`;
    return fetchDataPostReq(url, data);
  }
}

const commonService = new CommonService();
export default commonService;
